export const silabsOtaService = '1d14d6ee-fd63-4fa1-bfa4-8f47b42119f0';
export const silabsOtaControlChar = 'f7bf3564-fb6d-4e53-88a4-5e37e0326063';
export const silabsOtaDataChar = '984227f3-34fc-4045-a5d0-2c581f81a153';
export const silabsOtaAppVersionChar = '0d77cc11-4ac1-49f2-bfa9-cd96ac7a92f8';
export const silabsOtaLoaderVersionChar = '4cc07bcf-0868-4b32-9dad-ba4cc41e5316';
export const silabsOuis = [
    '000B57',
    '003C84',
    '040D84',
    '048727',
    '04CD15',
    '04E3E5',
    '086BD7',
    '08B95F',
    '08DDEB',
    '0C2A6F',
    '0C4314',
    '0CAE5F',
    '0CEFF6',
    '142D41',
    '14B457',
    '187A3E',
    '1C34F1',
    '1CC089',
    '286847',
    '287681',
    '28DBA7',
    '2C1165',
    '30FB10',
    '3410F4',
    '3425B4',
    '38398F',
    '385B44',
    '385CFB',
    '3C2EF5',
    '403059',
    '44E2F8',
    '4C5BB3',
    '4C97A1',
    '50325F',
    '540F57',
    '583BC2',
    '588E81',
    '5C0272',
    '5CC7C1',
    '60A423',
    '60B647',
    '60EFAB',
    '680AE2',
    '6C5CB1',
    '6CFD22',
    '705464',
    '70AC08',
    '70C59C',
    '7CC6B6',
    '804B50',
    '842712',
    '842E14',
    '847127',
    '84B4DB',
    '84BA20',
    '84FD27',
    '881A14',
    '8C65A3',
    '8C6FB9',
    '8CF681',
    '9035EA',
    '90395E',
    '90AB96',
    '90FD9F',
    '943469',
    '94B216',
    '94DEB8',
    '94EC32',
    '980C33',
    'A46DD4',
    'A49E69',
    'B0C7DE',
    'B43522',
    'B43A31',
    'B4E3F9',
    'BC026E',
    'BC33AC',
    'C4D8C8',
    'CC86EC',
    'CCCCCC',
    'D0CF5E',
    'D44867',
    'D87A3B',
    'DC8E95',
    'E0798D',
    'E406BF',
    'E8E07E',
    'EC1BBD',
    'ECF64C',
    'F082C0',
    'F4B3B1',
    'F84477',
    'FC4D6A',
];
export const atmosicOuis = ['F0AD4E'];
export const pikachuService = '06caf9c0-74d3-454f-9be9-e30cd999c17a';
export const pikachuCharacteristicBase = 'f9a98c15-c651-4f34-b656-d100bf58';
export const loraxService = 'e276967f-ea8a-478a-a92e-d78f5dd15dd5';
export const loraxVersionChar = '05434bca-cc7f-4ef6-bbb3-b1c520b9800c';
export const loraxCommandChar = '60133d5c-5727-4f2c-9697-d842c5292a3c';
export const loraxReplyChar = '8dc5ec05-8f7d-45ad-99db-3fbde65dbd9c';
export const loraxEventChar = '43312cd1-7d34-46ce-a7d3-0a98fd9b4cb8';
export const pupService = '420b9b40-457d-4abe-a3bf-71609d79581b';
export const pupTriggerChar = 'c830ee3e-0e32-4780-a51d-b1b0b38089a4';
export const pupAppVersionChar = '58b0a7aa-d89f-4bf2-961d-0d892d7439d8';
export const pupAppHashChar = '4daad5ae-8a9e-417d-924d-b237ac64ad9c';
export const pupDeviceInfoChar = '2dab0217-8a4e-4de8-83c7-8fded59f4599';
export const pupSerialNumberChar = 'a5fa5a5d-f28e-47d9-b95b-f82c06177503';
export const pupGeneralCommandChar = 'c364cf1d-117f-4a3b-baae-3e2fce5a248f';
export const pupGeneralCommandResponseChar = 'baeb965b-58ac-43bf-9cc5-bfb448ec2e72';
export const pupBootloaderVersionChar = '0d7ec9f3-efe4-4e51-aea0-3a1477a9c37e';
export const pupBootloaderHashChar = '5c03d675-2588-490f-87dc-b88772934bbb';
//# sourceMappingURL=uuids.js.map